import React from 'react';
import '../../styles/RailTile.css';
import PropTypes from 'prop-types';

const PartiallyCancelled = ({
  trainName,
  trainNo,
  trainSrc,
  trainDstn,
  startDate,
  trainType,
  cncldFrmStn,
  cncldToStn
}) => {
  return (
    <div className="railTile">
      <div className="trainNameNoWrap">
        <span className="blackText latoBlack trainName">{trainName}</span>
        <span className="lightGreyText trainNo">{trainNo}</span>
      </div>
      <div className="trainOtherInfo">
        <div className="stationDateInfo">
          <span className="">{trainSrc}</span>
          <span className="longArrowIcon railSeoSprite appendRight10 appendLeft10"></span>
          <span className="">{trainDstn}</span>
          <span className="appendRight10 appendLeft10 lightGreyText">|</span>
          <span className="">{startDate}</span>
          <span className="appendRight10 appendLeft10 lightGreyText">|</span>
          <span className="">{trainType}</span>
          <span className="appendRight10 appendLeft10 sprater lightGreyText">|</span>
        </div>
        <div className="cancelInfo">
          <span className="lightGreyText appendRight20">Partially Cancelled from</span>
          <span className="pushRight">
            <span className="yellowText">{cncldFrmStn}</span>
            <span className="orglongArrowIcon railSeoSprite appendRight10 appendLeft10"></span>
            <span className="yellowText">{cncldToStn}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

PartiallyCancelled.propTypes = {
  trainName: PropTypes.string,
  trainNo: PropTypes.string,
  trainSrc: PropTypes.string,
  trainDstn: PropTypes.string,
  startDate: PropTypes.string,
  trainType: PropTypes.string,
  cncldFrmStn: PropTypes.string,
  cncldToStn: PropTypes.string
};

export default PartiallyCancelled;
